import { twMerge } from 'tailwind-merge';

import { BOOST_CATEGORY, Boost } from '@packages/types';

import { Button } from '@elements/button';
import { i18n } from '@i18n';
import { ROUTE_PATHS, router } from '@routes/router';
import { getTripSelector, useTripStore } from '@store';

export type BenefitsAndExcessProps = {
  onClick: () => void;
  hasFullBenefitsDisplayed?: boolean;
};

export const BenefitsAndExcess = ({
  onClick,
  hasFullBenefitsDisplayed,
}: BenefitsAndExcessProps) => {
  const trip = useTripStore(getTripSelector);
  const essentialBoost =
    trip.boosts.find(boost => boost.category === BOOST_CATEGORY.MY_HEALTH) ?? ({} as Boost);

  return (
    <div
      className={twMerge(
        'flex  sm:justify-center relative',
        hasFullBenefitsDisplayed && 'justify-between',
        !hasFullBenefitsDisplayed && 'justify-center',
      )}>
      {hasFullBenefitsDisplayed ? (
        <Button
          className="sm:absolute top-0 left-0"
          icon="keyboard_arrow_up"
          size="md"
          variant="secondary"
          onClick={onClick}
        />
      ) : null}

      <Button
        variant="secondary"
        onClick={async () => {
          if (!hasFullBenefitsDisplayed) {
            return onClick();
          }
          router.navigate(ROUTE_PATHS().boostDetails(essentialBoost?.boostId));
        }}
        title={
          hasFullBenefitsDisplayed
            ? i18n.t('myQuote.overseasBenefits.actions.policy')
            : i18n.t('myQuote.overseasBenefits.actions.benefits')
        }
      />
    </div>
  );
};
